import 'vue-multiselect/dist/vue-multiselect.css';
import 'floating-vue/dist/style.css';
import App from '@/App.vue';
import {i18n} from '@/locales/i18n';
import router from '@/router';
import FloatingVue from 'floating-vue';
import {createPinia} from 'pinia';
import * as Sentry from '@sentry/vue';

import {createApp} from 'vue';
import {setLocale} from '@/services/translation.service';

const pinia = createPinia();

const app = createApp(App);

const sentry = window.sentrySettings;

if (sentry?.dsn) {
	Sentry.init({
		app,
		dsn: sentry.dsn,
		environment: sentry.environment,
		release: sentry.release,
		integrations: [
			Sentry.browserTracingIntegration({router}),
		],
		tracesSampleRate: 0.5,
	});
}

app.use(router);
app.use(i18n);
app.use(pinia);
app.use(FloatingVue);

setLocale(window.languageIso)
	.finally(() => app.mount('#app'));
